import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
@Component({
  selector: 'app-data-edit',
  templateUrl: './data-edit.component.html',
  styleUrls: ['./data-edit.component.scss']
})
export class DataEditComponent implements OnInit {

  displayedColumns: any;
  columnsToDisplay: any;
  values: any;
  title = 'Edit Data';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DataEditComponent>) {
    if (data && data.displayedColumns && data.columnsToDisplay && data.values) {
      this.columnsToDisplay = data.columnsToDisplay;
      this.displayedColumns = data.displayedColumns;
      this.values = data.values;
      if (data.title) {
        this.title = data.title;
      }
    }
  }

  ngOnInit() {
  }

  close(sumbit) {
    this.dialogRef.close({
      isSubmit: sumbit,
      values: this.values
    });
  }

}
